import { useEventSource } from '@repo/react-hooks';
import { env } from '@/lib/env';
import { WalletResponseType } from '@/lib/fetch';
import { useAppStore } from '@/providers/AppStoreProvider';

interface StreamResponse {
  changeType: 'credit' | 'debit';
  changeAmount: number;
  currency: string;
  eventType: 'game' | 'bonus-adjustment' | 'wallet-adjustment' | 'withdrawal' | 'deposit';
}

/**
 * Hook to listen to the wallet balance changes sent by the server through SSE.
 */
const useSseWithWalletBalance = (onStreamResponse?: (streamResponse: StreamResponse) => void) => {
  const { accessToken } = useAppStore((state) => ({ accessToken: state.accessToken }));

  return useEventSource<WalletResponseType>(env.NEXT_PUBLIC_API_WALLET_BASE_URL + '/api/v1/wallets/balance/stream', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    openWhenHidden: true,
    onmessage: (event) => {
      if (event.data) {
        console.log('useSseWithWalletBalance :: Event received', event.data);
        onStreamResponse?.(JSON.parse(event.data));
      }
    },
    onerror: (error) => {
      console.error('useSseWithWalletBalance :: Connection error ::', error);
      throw error;
    },
    onclose: () => {
      console.log('useSseWithWalletBalance :: Connection closed');
    },
  });
};

export default useSseWithWalletBalance;
